'use strict';

var Stringify = require('./stringify');
var Parse = require('./parse');

module.exports = {
    stringify: Stringify,
    parse: Parse
};



/** WEBPACK FOOTER **
 ** ./~/isomorphic-mapzen-search/~/qs/lib/index.js
 **/